import { FC, useState, useEffect } from 'react';
import { EditableComponent, ResponsiveGrid } from '@adobe/aem-react-editable-components';
import { calculateTimeLeft, checkCampaignStatus } from '../../utils/OfferUtils';
import { shouldUseMockData } from '../../utils/CommonUtils';
import { OnOffContainerProps } from './OnOffContainer.types';
import clsx from 'clsx';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const OnOffContainerWrapper = (props: any) => {
  const { isAuthorMode, offersData, model } = props;
  const { variation } = model;
  /* eslint-disable @typescript-eslint/no-explicit-any */
  const [offersDataMock, setoffersDataMock] = useState<any>({});
  const GetMockData = async (isAuthorMode: boolean) => {
    if (shouldUseMockData(isAuthorMode)) {
      const mockData = await import('./__mock__/OnOffContainerMock.mock');
      return mockData.offersDataMock;
    }
    return {};
  };

  useEffect(() => {
    const fetchMockData = async () => {
      const mockData = await GetMockData(isAuthorMode);
      setoffersDataMock(mockData);
    };

    fetchMockData();
  }, [isAuthorMode]);

  const { campaignStartDate = '', campaignEndDate = '' } = !isAuthorMode ? offersData : offersDataMock;
  const [utilityState, setUtilityState] = useState<string>(checkCampaignStatus(campaignStartDate, campaignEndDate));

  useEffect(() => {
    if (isAuthorMode) return;
    const updateTime = () => {
      const newTimeLeft = calculateTimeLeft(campaignStartDate, isAuthorMode);

      if (newTimeLeft.days === 0 && newTimeLeft.hours === 0 && newTimeLeft.minutes === 0 && newTimeLeft.seconds === 0) {
        setUtilityState(checkCampaignStatus(campaignStartDate, campaignEndDate));
      }
    };
    const interval = setInterval(updateTime, 1000);
    return () => clearInterval(interval);
  }, [isAuthorMode, campaignStartDate, campaignEndDate]);

  if (variation === utilityState || isAuthorMode) {
    return <ResponsiveGrid isInEditor={true} customClassName={clsx(model?.appliedCssClassNames)} {...props} />;
  }

  return <></>;
};

export const OnOffContainerWrapperConfig = {
  emptyLabel: 'OnOffContainer',
  isEmpty: false,
  resourceType: `mi-aem-offers-spa/components/onoffcontainer`,
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const OnOffContainer: FC<OnOffContainerProps> = (props: any) => {
  return (
    <EditableComponent config={OnOffContainerWrapperConfig} {...props}>
      <div data-testid="offers-OnOffContainer" data-component-name="o-offers-OnOffContainer">
        <OnOffContainerWrapper {...props} />
      </div>
    </EditableComponent>
  );
};
